// extracted by mini-css-extract-plugin
export var container = "_5c-1";
export var cornerButtonContainer = "_5c-5";
export var disabled = "_5c-2";
export var fileContainer = "_5c-4";
export var hiddenInput = "_5c-3";
export var widthContainer = "_5c-0";